import { ReactElement, useContext } from "react";
import { styled } from "styled-components";
import { HostThemeConfig, HostThemeConfigContext } from "../../../../components/providers/theme/HostThemeConfigContext";

const RootContainer = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${p => p.theme.colorPrimaryActive};
  color: ${p => p.theme.colorWhite};
  padding: ${p => p.theme.paddingXXS}px;
`;

const LogoImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

export default function CrmMinimized(): ReactElement {
  const hostThemeConfig = useContext(HostThemeConfigContext);

  return (
    <RootContainer>
      <LogoImage src={getIconUrl(hostThemeConfig)} alt="" />
    </RootContainer>
  );
}

function getIconUrl(config: HostThemeConfig | null): string {
  if (!config)
    return "/graia-small-logo.svg";

  // deprecated logoUrlWhite kept for backward compatibility
  // eslint-disable-next-line @typescript-eslint/no-deprecated
  return (config.logoSimpleUrl || config.logoUrlWhite) ?? "";
}
